"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorNotification = exports.ErrorNotification = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const I18n_1 = require("@reactionable/core/lib/i18n/I18n");
const ErrorNotification_1 = require("@reactionable/core/lib/ui/notification/ErrorNotification");
const ErrorAlert_1 = require("../alert/ErrorAlert");
const Notification_1 = require("./Notification");
const ErrorNotification = (_a) => {
    var { title, children } = _a, props = tslib_1.__rest(_a, ["title", "children"]);
    const { t } = I18n_1.useTranslation();
    if (!title) {
        title = t("An error has occured");
    }
    return (jsx_runtime_1.jsx(Notification_1.Notification, Object.assign({ variant: "danger", title: title }, props, { children: jsx_runtime_1.jsx(ErrorAlert_1.ErrorAlert, Object.assign({ className: "mb-0" }, { children: children }), void 0) }), void 0));
};
exports.ErrorNotification = ErrorNotification;
const useErrorNotification = (props) => {
    return ErrorNotification_1.useErrorNotification(Object.assign(Object.assign({}, props), { Component: exports.ErrorNotification }));
};
exports.useErrorNotification = useErrorNotification;
//# sourceMappingURL=ErrorNotification.js.map